import { render, staticRenderFns } from "./StockOpeningBalance.vue?vue&type=template&id=75f1a917&"
import script from "./StockOpeningBalance.vue?vue&type=script&lang=js&"
export * from "./StockOpeningBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports